import { Tooltip } from "@mui/material";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

export enum HintSubjects {
    Body = '',
    Sharpness = '',
    Initiative = '',

    Focus = '/rules#focus'
}
type Hints = 'gawker' | 'initiative' | 'fall';
//TODO zmienić na 
export const Ref = ({ subject, children }: { subject?: HintSubjects | Hints, children: ReactNode }) => (
    <Tooltip title={"hint"} arrow placement="top" >
        <Link to={subject ? subject : ''} style={{ fontStyle: 'italic', textDecoration: 'none', color: 'inherit' }} >
            <u>{children}</u>
        </Link>
    </Tooltip>

)